<template>
  <div>
    <slot name="body"></slot>

    <div v-if="model">
      <ul class="col-md-12" >
        <li v-for="(attachment, index) in attachments" :key='index'>
          <a target="_blank" :href="getAttachmentPath(attachment)">{{attachment.AttachmentName}}</a>
        </li>
      </ul>
      <br style="clear: both;" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    model: Object
  },

  data() {
    return {
      attachments: []
    }
  },

  methods: {
    getAttachmentPath(item) {
      return this.api.$.privateResources + 'MediaFiles/' + item.AttachmentFile
    }
  },

  created() {
    if (this.model && this.model.Data) {
      let data = JSON.parse(this.model.Data)
      this.attachments = data.Attachments
    }
  }
}
</script>

<style scoped lang='scss'>
ul {
  list-style-type: none;
}
</style>



// WEBPACK FOOTER //
// src/components/_modules/Invoices/cells/attachments-details.vue